module.exports = __webpack_public_path__ + "5a98653331e9dfaaab8b03a093469afb.MP3";